import React from 'react'

import { Form, Input, InputNumber, Upload, Button, Row, Col, message, Modal, notification } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createTourPackage } from '../../../api/tour-package.service';

export default function AddTourPackageModal({ isModalOpen, setIsModalOpen, handleOk, handleCancel, fetchVehicles }) {
    const onFinish = async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (key === "picture" && values.picture) {
                formData.append(key, values.picture[0].originFileObj);
            } else {
                formData.append(key, values[key]);
            }
        });
        try {
            await createTourPackage(formData);
            notification.success({ message: "Package added" });
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          message.error("You can only upload image files!");
        }
        return isImage ? false : Upload.LIST_IGNORE; // Prevent Ant Design from uploading automatically
      };

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add Tour Package" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{
                    name: "",
                    description: "",
                    supplierEmail: "",
                    priceInPKR: 0,
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Tour Package Name" name="name" rules={[{ required: true, message: "Please enter package Name" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Duration" name="description" rules={[{ required: true, message: "Please enter description" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                    <Col span={12}>
                            <Form.Item label="Supplier Email" name="supplierEmail" rules={[{ required: true, message: "Please enter supplier email" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Price (PKR)" name="priceInPKR" rules={[{ required: true, message: "Please enter price" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        
                        <Col span={12}>
                            <Form.Item rules={[{ required: true, message: "Picture is required" }]} label="Tour Picture" name="picture" valuePropName="fileList" getValueFromEvent={(e) => e && e.fileList}>
                                <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};